<template>
  <section class="section">
    <div class="grid-container">
      <div
        v-for="(stop, index) in stops"
        :key="index"
        class="grid-item"
        @click="openLocation(index)"
      >
        <figure class="item-image">
          <img v-lazy="getImage(index)" :alt="stop" />
        </figure>
        <div class="item-content">
          <p>{{ stop }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Stops",
  computed: {
    selected() {
      return this.$store.state.selected;
    },
    language() {
      return this.$store.state.language;
    }
  },
  data() {
    return {
      stops: [
        "Hoge Hall",
        "Hillcrest Hall",
        "Old Turner St",
        "Lane Hall",
        "O’Shaughnessy",
        "D2 Plaza",
        "Burruss Hall",
        "Squires BCC"
      ]
    };
  },
  methods: {
    openLocation(index) {
      this.$store.commit("setSelected", index);
      this.$router.push({ path: "/" }, () => {
        this.$store.commit("setMapVisibility", false);
      });
    },
    getImage(index) {
      return require(`@/assets/stopicons/${index}.jpg`);
    }
  }
};
</script>

<style lang="scss" scoped>
section {
  padding: 3vh 2vw;
  background: $red-gradient;
  display: flex;
  justify-content: center;
  align-items: center;
}

.grid-container {
  display: grid;
  justify-content: center;
  align-items: center;
  grid-gap: 2vh 6vw;
  grid-template-columns: 40vw 40vw;
  grid-template-rows: 16vh;
}

.grid-item {
  cursor: pointer;
  width: 40vw;
  height: 18vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .item-content {
    height: 2vh;
    color: $lightGrey;
  }
  .item-image {
    img {
      height: 14vh;
      width: 38vw;
      border-radius: 10px;
      box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.25);
      object-fit: cover;
      object-position: center top;
    }
  }
}
</style>
